import styled from 'styled-components'

import colors from 'styles/colors'

export const Loader = () => {
    return (
        <Container>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </Container>
    )
}

const Container = styled.div`
    margin: auto;
    top: 45%;
    position: relative;
    width: 5rem;
    height: 5rem;

    span {
        display: block;
        position: absolute;
        width: 4rem;
        height: 4rem;
        margin: 4px;
        border: 4px solid ${colors.black};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${colors.blue} transparent transparent transparent;

        &:nth-child(1) {
            animation-delay: -0.45s;
        }
        &:nth-child(2) {
            animation-delay: -0.3s;
        }
        &:nth-child(3) {
            animation-delay: -0.15s;
        }
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`
